"use client";

import { DISPLAY_CURRENCIES, PUBLIC_CURRENCY_SELECTOR_ENABLED } from "@/greenpak/display-currency";
import { useDisplayCurrency } from "./CurrencyProvider";

export function CurrencySelector({ compact = false }: { compact?: boolean }) {
  const { currency, setCurrency } = useDisplayCurrency();

  if (!PUBLIC_CURRENCY_SELECTOR_ENABLED) {
    return (
      <span
        className={
          compact
            ? "inline-flex h-10 items-center px-2 text-[12px] font-semibold text-[var(--foreground)]"
            : "block text-sm font-semibold text-[var(--foreground)]"
        }
      >
        PKR · Pakistani Rupee
      </span>
    );
  }

  return (
    <label className={compact ? "inline-flex items-center" : "block"}>
      <span className="sr-only">Display currency</span>
      <select
        value={currency}
        onChange={(event) => setCurrency(event.target.value as typeof currency)}
        aria-label="Display currency"
        className={
          compact
            ? "h-10 min-w-[84px] cursor-pointer rounded border border-[var(--border-subtle)] bg-[var(--surface)] px-2 text-[12px] font-semibold text-[var(--foreground)] outline-none focus:border-[var(--accent)]"
            : "pbd-booking-field mt-1"
        }
      >
        {DISPLAY_CURRENCIES.map((item) => (
          <option key={item.code} value={item.code}>
            {item.code} · {item.label}
          </option>
        ))}
      </select>
    </label>
  );
}
